

























































































import { Component, Vue } from 'vue-property-decorator';
import { queryUpdateStock, updateStock } from "@/utils/api";
import Clipboard from 'clipboard';

@Component
export default class UpdateInventory extends Vue {
  skuCodeLists: string = '';//sku编码数据
  skuIdLists: string = '';//skuId数据
  skuCodeInfo: string = '部分添加失败，请检查数据格式，商品SKUID是否正确';//报错提示信息
  disabled: boolean = true;//按钮是否可点击
  reportError: boolean = false;//数据是否验证通过
  tableLoading: boolean = false;//表格加载
  tableData: Array<object> = [];//表格数据
  btnLoading: boolean = false;//按钮加载框
  dialogVisible: boolean = false;//弹窗
  failureList: Array<string> = [];//失败列表

  /* 输入的数据转化数组 */
  conversion(value){
    let data = value.replace(/(^\s*)|(\s*$)/g, "");
    if(data == ''){
      this.disabled = true;
    }else{
      this.disabled = false;
      let val = data.split(/\n+/);
      if(val.length > 200){
        this.skuIdLists = (val.slice(0,200)).join('\n');
      }
    }
  }
  /* 添加 */
  addTo(){
    let skuIdData = this.skuIdLists;
    let data = (skuIdData.replace(/(^\s*)|(\s*$)/g, "")).split(/\n+/);
    let skuIdList = [];
    for (let i = 0; i < data.length; i++) {
      const el = data[i];
      let skuInfo = (el.replace(/(^\s*)|(\s*$)/g, "")).split(/\s+/);
      if(skuInfo.length > 2){
        this.reportError = true;
        this.skuCodeInfo = '添加失败，请检查数据格式，商品SKUID是否正确';
        break;
      }else{
        if(skuInfo.length > 1){
          let stockCount = skuInfo[1];
          if(stockCount.indexOf('.') == -1){
            if(Number(stockCount) >= 0 && Number(stockCount) <= 99999){
              skuIdList.push({skuId:skuInfo[0],stockCount:Number(skuInfo[1])});
              this.reportError = false;
            }else{
              this.reportError = true;
              this.skuCodeInfo = '添加失败，请检查数据格式，库存数量不支持小于0或大于99999修改';
              break;
            }
          }else{
            this.reportError = true;
            this.skuCodeInfo = '添加失败，请检查数据格式，库存数量不支持小数点，只支持整数';
            break;
          }
        }else{
          this.reportError = false;
          skuIdList.push({skuId:skuInfo[0],stockCount:null})
        }
      }

    }

    if(!this.reportError){
      console.log(skuIdList);
      this.queryUpdateStock(skuIdList);
    }
  }
  /* 移除商品 */
  removeCommodity(row){
    console.log(row);
    let tableData = this.tableData;
    let skuId = row.skuId;
    let index = tableData.findIndex((item: any)=> {return item.skuId == skuId});
    tableData.splice(index, 1);
  }
  /* 重置数据 */
  reset(){
    this.skuIdLists = '';
    this.disabled = true;
    this.reportError = false;
    this.tableLoading = false;
    this.tableData = [];
  }
  /* 提交数据 */
  referTo(){
    let tableData = this.tableData;
    let passNot = true;
    for (let i = 0; i < tableData.length; i++) {
      const el: any = tableData[i];
      if(el.updateStock == null || el.updateStock == ''){
        this.$message.error(`第${i + 1}行为空,请输入库存修改数`);
        passNot = false;
        break;
      }
      if(Number(el.updateStock) < el.preStock){
        this.$message.error(`第${i + 1}行修改库存数量小于订单占用库存数量，请重新修改`);
        passNot = false;
        break;
      }
    }
    if(passNot){
      this.$confirm('确认更新库存吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(() => {
        this.updateStock(this.tableData);
      })
    }
  }

  // 查询列表数据
  queryUpdateStock(data){
    this.tableLoading = true;
    queryUpdateStock(data).then((res: any) => {
      console.log(res);
      let error = res.error;
      let results = res.results;
      this.handleUpdateStockData(error,results);
    }).finally(()=> {
      this.tableLoading = false;
    })
  }
  /* 提交库存更新数据 */
  updateStock(data){
    this.btnLoading = true;
    updateStock(data).then((res: any) => {
      console.log(res);
      if(res.length > 0){
        this.dialogVisible = true;
        this.failureList = res;
      }else{
        this.$message({
          type: 'success',
          message: '更新库存完成!'
        });
        this.reset();
      }
    }).finally(()=> {
      this.btnLoading = false;
    })
  }
  /* 处理查询出来的数据 */
  handleUpdateStockData(error,results){
    if(error.length){
      let str = '';
      error.forEach(el => {
        if(el.stockCount != null){
          str += `${el.skuId} ${el.stockCount}\n`;
        }else{
          str += `${el.skuId}\n`;
        }
      });
      this.skuIdLists = str;
      if(results.length){
        this.skuCodeInfo = `部分添加失败，请检查数据格式，商品SKUID是否正确`;
      }else{
        this.skuCodeInfo = `添加失败，请检查数据格式，商品SKUID是否正确`;
      }
      this.reportError = true;
    }else{
      this.skuIdLists = '';
      this.disabled = true;
    }
    let tableData = this.tableData;
    if((tableData.length + results.length) > 200){
      this.skuCodeInfo = `当前添加至下方列表内的行数据总数已超过200条，您还可添加${ 200 - tableData.length }条数据，请仔细核对`;
      this.reportError = true;
    }else{
      let tableList = tableData.concat(results);
      const map = new Map()
      this.tableData = tableList.filter((item: any) => !map.has(item.skuId) && map.set(item.skuId, true));
    }
  }
  /* 一键复制 */
  copy(e) {
    let text = this.failureList.join('\n');
    const clipboard: any = new Clipboard(e.target, { text: () => text });
    clipboard.on('success', e => {
        this.$message({
          message: '复制成功',
          type: 'success'
        });
        // 释放内存
        clipboard.off('error')
        clipboard.off('success')
        clipboard.destroy()
    })
    clipboard.on('error', e => {
      // 不支持复制
      this.$message.error('复制失败');
      // 释放内存
      clipboard.off('error')
      clipboard.off('success')
      clipboard.destroy()
    })
    clipboard.onClick(e)
  }
  /* 判断是否小于订单占用库存 */
  discoloration(data){
    if(data.row.updateStock){
      if(Number(data.row.updateStock) < Number(data.row.preStock)){
        return 'update_stock_red update_inventory_table_list_update_stock'
      }else{
        return 'update_inventory_table_list_update_stock'
      }
    }
  }
}
